import { render } from "./InitialDepositRetry.vue?vue&type=template&id=61351fbc&scoped=true"
import script from "./InitialDepositRetry.vue?vue&type=script&lang=js"
export * from "./InitialDepositRetry.vue?vue&type=script&lang=js"

import "./InitialDepositRetry.vue?vue&type=style&index=0&id=61351fbc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61351fbc"]])

export default __exports__